const _RMI = new WeakMap();
const _appDefId = new WeakMap();
const _contextId = new WeakMap();
const _compId = new WeakMap();
const _compName = new WeakMap();
const _controllerId = new WeakMap();
const _emitter = new WeakMap();
const _role = new WeakMap();
const _styleInstance = new WeakMap();
const _type = new WeakMap();
const _wixSelector = new WeakMap();

export {
    _RMI,
    _appDefId,
    _contextId,
    _compId,
    _compName,
    _controllerId,
    _emitter,
    _role,
    _styleInstance,
    _type,
    _wixSelector
};
